module.exports = __webpack_public_path__ + "static/media/me.6f968799.svg";